import React from 'react'
import { is } from 'ramda'
import keyCodes from 'src/lib/util/keyCodes'

/*
  Executes functions when defined keys are pressed (on keyup)

  Other options may be set as siblings to `keys` option

  USAGE
    ```
    withkeyHandlers({
      keys: {
        [keyCode]: this.props => void
      }
    })
    ```  
*/

const getKeyCode = key => (is(Number, key) ? key : keyCodes[key])

export default options => WrappedComponent =>
  class extends React.Component {
    static displayName = `withKeyHandlers(${
      WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`

    handleKeys = event => {
      const { keys } = options
      const keyCode = event.which || event.keyCode

      Object.entries(keys).forEach(([key, handler]) => {
        if (getKeyCode(key) === keyCode) {
          handler(this.props)
        }
      })
    }

    componentDidMount() {
      if (options.keys) {
        window.addEventListener('keyup', this.handleKeys)
      }
    }

    componentWillUnmount() {
      if (options.keys) {
        window.removeEventListener('keyup', this.handleKeys)
      }
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
